import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StandardLayout from '../../../components/layout/StandardLayout';
import { createExamSubcategory, getExams } from '../../../services/examAPIService';
import { XMarkIcon } from '@heroicons/react/24/outline';

const ExamSubcategoryCreateForm = () => {
    const [formData, setFormData] = useState({
        title: '',
        exam_id: ''
    });
    const [exams, setExams] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        loadExams();
    }, []);

    const loadExams = async () => {
        try {
            const data = await getExams();
            setExams(data);
            setError(null);
        } catch (err) {
            setError('Fehler beim Laden der Prüfungen');
            console.error('Error loading exams:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const submitData = {
                title: formData.title,
                exam_id: parseInt(formData.exam_id)
            };
            
            await createExamSubcategory(submitData);
        } catch (error) {
            console.error('Error creating exam subcategory:', error);
            setError('Fehler beim Erstellen des Prüfungsteils');
        }
    };

    const handleCancel = () => {
        navigate('/admin');
    };

    if (loading) {
        return (
            <StandardLayout>
                <div className="flex justify-center items-center min-h-screen">
                    <span className="loading loading-spinner loading-lg text-primary"></span>
                </div>
            </StandardLayout>
        );
    }

    return (
        <StandardLayout>
            <div className="container mx-auto px-4 py-8">
                <div className="max-w-2xl mx-auto">
                    <h1 className="text-2xl font-bold mb-6">Neuen Prüfungsteil erstellen</h1>
                    
                    {error && (
                        <div className="alert alert-error mb-4">
                            <XMarkIcon className="w-6 h-6" />
                            <span>{error}</span>
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text">Prüfung</span>
                            </label>
                            <select
                                name="exam_id"
                                value={formData.exam_id}
                                onChange={handleInputChange}
                                className="select select-bordered w-full"
                                required
                            >
                                <option value="">Prüfung auswählen</option>
                                {exams.map(exam => (
                                    <option key={exam.id} value={exam.id}>
                                        {exam.title}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="form-control">
                            <label className="label">
                                <span className="label-text">Titel</span>
                            </label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                className="input input-bordered w-full"
                                placeholder="Geben Sie den Titel des Prüfungsteils ein"
                                required
                            />
                        </div>

                        <div className="flex justify-end gap-4">
                            <button
                                type="button"
                                onClick={handleCancel}
                                className="btn btn-ghost"
                            >
                                Abbrechen
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                            >
                                Prüfungsteil erstellen
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </StandardLayout>
    );
};

export default ExamSubcategoryCreateForm; 